import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@windmill/react-ui";
import { useTranslation } from "react-i18next";
import Error from "components/form/Error";
import LabelArea from "components/form/LabelArea";
import InputLogin from "components/form/InputLogin";
import { FaUserLock } from "react-icons/fa6";
import { IoIosRefresh } from "react-icons/io";
import useLoginSubmit from "../hooks/useLoginSubmit";
import axios from "axios";

const Login = () => {
  const { t } = useTranslation();
  const {
    onSubmit,
    register,
    trigger,
    handleSubmit,
    errors,
    loading,
    setValue,
    clearErrors,
    setError,
  } = useLoginSubmit();
  const [rememberMe, setRememberMe] = useState(false);
  const [captchaText, setCaptchaText] = useState(generateCaptcha());

  const loginData = {
    username: "Admin Panel",
    password: "Admin@123",
  };

  function generateCaptcha() {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    return Array.from({ length: 5 })
      .map(() => characters[Math.floor(Math.random() * characters.length)])
      .join("");
  }

  const refreshCaptcha = () => {
    setCaptchaText(generateCaptcha());
    clearErrors("captcha");
    setValue("captcha", "");
  };

  const getAuthKey = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/login`,
        loginData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log(response,"response")
      if (response.status === 200 && response.data.status) {
        const { key } = response.data;
        localStorage.setItem("authkey", key);
        localStorage.setItem("authTime", Date.now().toString());
      } else {
        console.error("Login failed:", response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
useEffect(()=>{
    getAuthKey();
    // console.log("get key")
})
  useEffect(() => {
    getAuthKey();
    const storedRememberMe = localStorage.getItem("rememberMe") === "true";
    setRememberMe(storedRememberMe);

    if (storedRememberMe) {
      const storedEmail = localStorage.getItem("userEmail");
      const storedPassword = localStorage.getItem("userPassword");

      if (storedEmail) setValue("email", storedEmail);
      if (storedPassword) setValue("password", storedPassword);
    }
    // eslint-disable-next-line
  }, []);

  const handleRememberMeChange = () => {
    const newRememberMe = !rememberMe;
    setRememberMe(newRememberMe);
    localStorage.setItem("rememberMe", newRememberMe.toString());

    if (!newRememberMe) {
      localStorage.removeItem("userEmail");
      localStorage.removeItem("userPassword");
    }
  };

  return (
    <div className="flex items-center min-h-screen p-6 dark:bg-gray-900">
      <div
        className="flex-1 h-full max-w-md mx-auto overflow-hidden bg-white rounded-lg dark:bg-gray-800"
        style={{ boxShadow: "0px 0px 10px rgb(0 0 0 / 15%)" }}
      >
        <div className="flex flex-col overflow-y-auto md:flex-row">
          <main className="flex items-center justify-center w-full flex-col">
            <div className="flex justify-center items py-4 w-full bg-green-500">
              <span className="text-white rounded-full text-3xl">
                <FaUserLock />
              </span>
            </div>
            <div className="w-full p-6">
              <h1 className="mb-6 text-2xl font-semibold text-gray-700 dark:text-gray-200">
                Login
              </h1>
              <form
                onSubmit={handleSubmit((data) => {
                  if (data.captcha !== captchaText) {
                    setError("captcha", {
                      type: "manual",
                      message: "Captcha does not match",
                    });
                    return;
                  }
                  onSubmit(data, rememberMe);
                })}
              >
                <LabelArea label="Email" />
                <InputLogin
                  register={register}
                  trigger={trigger}
                  label="Email"
                  name="email"
                  type="email"
                  placeholder="test@example.com"
                  pattern={/^[^\s@]+@[^\s@]+\.[^\s@]+$/}
                />
                <Error errorName={errors.email} />

                <div className="mt-6" />
                <LabelArea label="Password" />
                <InputLogin
                  register={register}
                  trigger={trigger}
                  label="Password"
                  name="password"
                  type="password"
                  icon="true"
                  placeholder="***************"
                />
                <Error errorName={errors.password} />

                <div className="flex justify-between items-center mt-4 px-1">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="rememberMe"
                      className="form-checkbox"
                      checked={rememberMe}
                      onChange={handleRememberMeChange}
                    />
                    <label
                      htmlFor="rememberMe"
                      className="ml-2 text-sm text-gray-700 dark:text-gray-200"
                    >
                      {t("Remember Me")}
                    </label>
                  </div>

                  <Link
                    className="text-sm font-medium text-green-500 dark:text-green-400 hover:underline"
                    to="/forgot-password"
                  >
                    {t("ForgotPassword")}
                  </Link>
                </div>

                {/* Captcha Block */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mt-5">
                  <div className="flex items-center">
                    <span
                      className="px-3 py-1 rounded shadow"
                      style={{
                        backgroundColor: "#f0f0f0",
                        fontFamily: "'Courier New', Courier, monospace",
                        fontSize: "1.5rem",
                        letterSpacing: "0.2rem",
                        color: "#333",
                        fontWeight: "bold",
                        userSelect: "none",
                        width: "120px",
                        backgroundImage:
                          "repeating-linear-gradient(45deg, #f0f0f0, #f0f0f0 10px, #e0e0e0 10px, #e0e0e0 20px)",
                        border: "1px dashed #ccc",
                        filter: "blur(0.5px) contrast(120%)",
                      }}
                      onCopy={(e) => e.preventDefault()}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          transform: "skewX(-15deg)",
                        }}
                      >
                        {captchaText}
                      </span>
                    </span>
                    <button
                      type="button"
                      onClick={refreshCaptcha}
                      className="ml-3 text-green-600 text-2xl"
                      aria-label="Refresh Captcha"
                    >
                      <IoIosRefresh />
                    </button>
                  </div>

                  <div className="w-full">
                    <InputLogin
                      register={register}
                      trigger={trigger}
                      label="Captcha"
                      name="captcha"
                      type="text"
                      placeholder="Enter captcha"
                    />
                    <Error errorName={errors.captcha} />
                  </div>
                </div>

                <Button
                  disabled={loading}
                  type="submit"
                  className="mt-6 h-12 w-full"
                >
                  {t("LoginTitle")}
                </Button>
              </form>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Login;
